export enum NotificationErrorCode {
	FORM_NOT_VALID = 'FORM_NOT_VALID',
	NOTIFICATION_CREATED = 'NOTIFICATION_CREATED',
	NOTIFICATION_UPDATED = 'NOTIFICATION_UPDATED',
	GENERIC_ERROR = 'GENERIC_ERROR',
	NOTIFICATION_DELETED = 'NOTIFICATION_DELETED',
	EXPORT_AVVENUTO_CON_SUCCESSO = 'EXPORT_AVVENUTO_CON_SUCCESSO'
}
